<div class="calendar-filter mt-3 mb-3">
  <ng-container *ngIf="loading; else loaded">
    <div class="overlay">
      <div class="spinner">
        <nz-spin [nzSize]="'small'" nzSimple="true"></nz-spin>
      </div>
    </div>
  </ng-container>

  <ng-template #loaded>
    <ng-container *ngIf="months">
      <ul>
        <ng-container *ngFor="let monthItem of months">
          <li class="calendar-month-item float-lg-end">
          <span
            [ngClass]="getCssClass(monthItem, 'M')"
            [ngStyle]="getCssStyle(monthItem)"
            (click)="onSelectMonth(monthItem)"
            title="{{ showTooltip ? monthItem.info : null }}"
            ngbTooltip="{{ showTooltip ? monthItem.info : null }}">
            {{ monthItem.label }}
          </span>
          </li>
        </ng-container>
      </ul>
    </ng-container>

    <ng-container *ngIf="month && days">
      <ul>
        <ng-container *ngFor="let dayItem of days" >
          <li class="calendar-day-item size-{{ this.noOfDays }}">
          <span
            [ngClass]="getCssClass(dayItem, 'D')"
            [ngStyle]="getCssStyle(dayItem)"
            (click)="onSelectDay(dayItem)">
            {{ dayItem.label }}
          </span>
          </li>
        </ng-container>
      </ul>
    </ng-container>

    <ng-container *ngIf="day && hours">
      <ul>
        <ng-container *ngFor="let hourItem of hours">
          <li class="calendar-hour-item">
          <span
            [ngClass]="getCssClass(hourItem, 'H')"
            [ngStyle]="getCssStyle(hourItem)"
            (click)="onSelectHour(hourItem)">
            {{ hourItem.label }}
          </span>
          </li>
        </ng-container>
      </ul>
    </ng-container>
  </ng-template>
</div>
